module.exports = "<mat-sidenav-container>\n  <ngx-loading-bar color=\"#009688\"></ngx-loading-bar>\n  <router-outlet></router-outlet>\n</mat-sidenav-container>"